/**
 * Capture and expose build-time configuration for runtime usage.
 */

///////////////////////////////////////////////////////////////////////////////
// Pantheon                                                                 //
//////////////////////////////////////////////////////////////////////////////

export const API_ENDPOINT = import.meta.env.VITE_API_ENDPOINT!;
export const ADMIN_ENDPOINT = import.meta.env.VITE_ADMIN_ENDPOINT!;
export const LABS_ENDPOINT = import.meta.env.VITE_LABS_ENDPOINT!;
export const HERMES_ENDPOINT = import.meta.env.VITE_HERMES_ENDPOINT!;
export const HERMESV2_ENDPOINT = import.meta.env.VITE_HERMESV2_ENDPOINT!;
export const SUGGESTION_ENDPOINT = import.meta.env.VITE_SUGGESTION_ENDPOINT!;
export const WS_ENDPOINT = import.meta.env.VITE_WS_ENDPOINT!;
export const TIMELINE_URL = import.meta.env.VITE_TIMELINE_URL!;

//////////////////////////////////////////////////////////////////////////////
// Contentful                                                               //
//////////////////////////////////////////////////////////////////////////////

export const CONTENTFUL_ACCESS_TOKEN = import.meta.env
  .VITE_CONTENTFUL_ACCESS_TOKEN!;
export const CONTENTFUL_PREVIEW_ACCESS_TOKEN = import.meta.env
  .VITE_CONTENTFUL_PREVIEW_ACCESS_TOKEN!;
export const CONTENTFUL_PREVIEW = import.meta.env.VITE_CONTENTFUL_PREVIEW!;
export const CONTENTFUL_SPACE_ID = import.meta.env.VITE_CONTENTFUL_SPACE_ID!;

//////////////////////////////////////////////////////////////////////////////
// Codex                                                                    //
//////////////////////////////////////////////////////////////////////////////

export const CODEX_ENDPOINT = import.meta.env.VITE_CODEX_ENDPOINT!;

//////////////////////////////////////////////////////////////////////////////
// Sentry                                                                   //
//////////////////////////////////////////////////////////////////////////////

export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN!;

//////////////////////////////////////////////////////////////////////////////
// Application Environment                                                  //
//////////////////////////////////////////////////////////////////////////////

export const DEV = import.meta.env.DEV!;
export const DEPLOY_ENV = parseDeployEnv();
export const RELEASE_HASH = import.meta.env.VITE_RELEASE_HASH!;
export const DEFAULT_LOCALE = import.meta.env.VITE_DEFAULT_LOCALE ?? "en-AU";

/** Deployment environment as a validated enum. */
export enum DeployEnv {
  DEFAULT = "default",
  LOCAL = "local",
  STAGING = "staging",
  NEXT = "next",
  PRODUCTION_AU = "au",
  PRODUCTION_UK = "uk",
  PRODUCTION_US = "us",
}

function parseDeployEnv(): DeployEnv {
  const rawDeployEnv = import.meta.env.VITE_DEPLOY_ENV;
  switch (rawDeployEnv) {
    case "local":
    case "staging":
    case "next":
    case "au":
    case "uk":
    case "us":
      return rawDeployEnv as DeployEnv;
    default:
      // Default to not crashing the application
      return DeployEnv.DEFAULT;
  }
}
